module.exports = __webpack_public_path__ + "img/73200.e42be4fc.jpg";